import * as React from 'react';
import { useMemo, useCallback, useState } from 'react';
import { get } from 'lodash-es';
import { useSelector } from 'react-redux';
import LegendControl from './LegendControl';

const icons: any[] = [];
function useLegendControl(legends: string[]): any {
  const exclude = useSelector((state) => get(state, ['legend', 'exclude']));

  const avail = useMemo(() => {
    return legends.filter((e: string) => {
      return exclude.indexOf(e) === -1;
    });
  }, [legends, exclude]);

  const Control = useCallback(
    (props: any) => {
      return <LegendControl {...props} legends={legends} />;
    },
    [legends],
  );

  return [avail, Control];
}

export default useLegendControl;
